
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { canManageTelematicsConnection, usePermissions } from "../../UserPermissions.js";
import { Permission, Permissions_has } from "../../Shared/Roles.js";
import { isAvailable } from "../../Telematics/Feature.js";
import { isAvailable as isAvailable_1 } from "../../InventoryStates/Feature.js";
import { reactElement, reactApi } from "../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { React_useElmish_Z6C327F2E } from "../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { toProps, update as update_1, init as init_1 } from "../SystemRoleSettings/State.js";
import { createObj } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { join } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { AreaAnchorMenu } from "../../Widgets/AnchorMenu.js";
import { empty, singleton, append, delay, toList } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { singleton as singleton_1, ofArray } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { SectionContainer } from "../../Widgets/Container.js";
import { PermissionsView } from "../Permissions/View.js";
import { unwrap } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { NotificationSettingsSection } from "./Notifications/View.js";
import { ReceiverSettings } from "../Receivers/View.js";
import { InventoryNumberSettings } from "./Inventory/View.js";
import { InventoryStatesSettings } from "./InventoryStates/View.js";
import { ProtocolSettings } from "./Protocol/View.js";
import { AppLogoSettings } from "./Logo/View.js";
import { UnitsSettings } from "./Units/View.js";
import { LabelSettings } from "./Labels/View.js";
import { SSOSettings } from "./SSO/View.js";
import { TelematicsSettings } from "./Telematics/View.js";

export function SystemSettingsView(props) {
    let elems_13, elems, elems_12;
    const t = useTranslation()[0];
    const permissions = usePermissions();
    const canManageSso = props.AccountSettings.SsoEnabled && Permissions_has(permissions, new Permission(103, []));
    const canManageTelematics = isAvailable(props.AccountSettings) && canManageTelematicsConnection(permissions);
    const canManageInventoryStates = isAvailable_1(props.AccountSettings) && Permissions_has(permissions, new Permission(103, []));
    const canManageLabels = Permissions_has(permissions, new Permission(103, []));
    const patternInput_1 = reactApi.useState("permissions-section");
    const patternInput_2 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init_1(props.AccountSettings), update_1, (_arg, _arg_1) => {
    }), undefined, undefined);
    const systemRoleSettings = toProps(props.AccountSettings, patternInput_2[0], patternInput_2[1]);
    return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "grid-cols-[10rem,minmax(0,80rem)]"])], (elems_13 = [reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems = [createElement(AreaAnchorMenu, {
        Anchors: toList(delay(() => append(singleton({
            Id: "permissions-section",
            Label: t("settings.permissions"),
        }), delay(() => append(singleton({
            Id: "notifications-section",
            Label: t("notification_settings.customer_title"),
        }), delay(() => append(singleton({
            Id: "receivers-section",
            Label: t("settings.receivers"),
        }), delay(() => append(singleton({
            Id: "inventory-section",
            Label: t("settings.inventory.title"),
        }), delay(() => append(canManageInventoryStates ? singleton({
            Id: "inventory-states-section",
            Label: t("settings.inventory_states.title"),
        }) : empty(), delay(() => append(singleton({
            Id: "protocol-section",
            Label: t("settings.protocol.title"),
        }), delay(() => append(singleton({
            Id: "logo-section",
            Label: t("settings.logo.title"),
        }), delay(() => append(singleton({
            Id: "units-section",
            Label: t("settings.units.title"),
        }), delay(() => append(canManageLabels ? singleton({
            Id: "labels-section",
            Label: t("settings.labels.title"),
        }) : empty(), delay(() => append(canManageSso ? singleton({
            Id: "sso-section",
            Label: t("settings.sso.sso"),
        }) : empty(), delay(() => (canManageTelematics ? singleton({
            Id: "telematics-section",
            Label: t("settings.telematics.title"),
        }) : empty()))))))))))))))))))))))),
        OnSelectAnchor: patternInput_1[1],
        SelectedAnchor: patternInput_1[0],
    })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), reactElement("div", createObj(singleton_1((elems_12 = toList(delay(() => {
        let elems_1, Title;
        return append(singleton(reactElement("section", createObj(ofArray([["id", "permissions-section"], (elems_1 = [createElement(SectionContainer, (Title = t("settings.permissions"), {
            Content: createElement(PermissionsView, {
                AccountSettings: props.AccountSettings,
                SystemRoleSettings: unwrap(systemRoleSettings),
            }),
            Title: unwrap(Title),
        }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_2, Title_1;
            return append(singleton(reactElement("section", createObj(ofArray([["id", "notifications-section"], (elems_2 = [createElement(SectionContainer, (Title_1 = t("notification_settings.customer_title"), {
                Content: createElement(NotificationSettingsSection, null),
                Title: unwrap(Title_1),
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                let elems_3, Title_2;
                return append(singleton(reactElement("section", createObj(ofArray([["id", "receivers-section"], (elems_3 = [createElement(SectionContainer, (Title_2 = t("settings.receivers"), {
                    Content: createElement(ReceiverSettings, {
                        SystemRoleSettings: unwrap(systemRoleSettings),
                    }),
                    Title: unwrap(Title_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                    let elems_4, Title_3;
                    return append(singleton(reactElement("section", createObj(ofArray([["id", "inventory-section"], (elems_4 = [createElement(SectionContainer, (Title_3 = t("settings.inventory.title"), {
                        Content: createElement(InventoryNumberSettings, {
                            OnConfigurationChanged: props.OnConfigurationChanged,
                            SystemRoleSettings: unwrap(systemRoleSettings),
                            UserData: props.UserData,
                        }),
                        Title: unwrap(Title_3),
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), delay(() => {
                        let elems_5, Title_4;
                        return append(canManageInventoryStates ? singleton(reactElement("section", createObj(ofArray([["id", "inventory-states-section"], (elems_5 = [createElement(SectionContainer, (Title_4 = t("settings.inventory_states.title"), {
                            Content: createElement(InventoryStatesSettings, null),
                            Title: unwrap(Title_4),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                            let elems_6, Title_5;
                            return append(singleton(reactElement("section", createObj(ofArray([["id", "protocol-section"], (elems_6 = [createElement(SectionContainer, (Title_5 = t("settings.protocol.title"), {
                                Content: createElement(ProtocolSettings, {
                                    UserData: props.UserData,
                                }),
                                Title: unwrap(Title_5),
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))), delay(() => {
                                let elems_7, Title_6;
                                return append(singleton(reactElement("section", createObj(ofArray([["id", "logo-section"], (elems_7 = [createElement(SectionContainer, (Title_6 = t("settings.logo.title"), {
                                    Content: createElement(AppLogoSettings, {
                                        OnConfigurationChanged: props.OnConfigurationChanged,
                                        UserData: props.UserData,
                                    }),
                                    Title: unwrap(Title_6),
                                }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))), delay(() => {
                                    let elems_8, Title_7;
                                    return append(singleton(reactElement("section", createObj(ofArray([["id", "units-section"], (elems_8 = [createElement(SectionContainer, (Title_7 = t("settings.units.title"), {
                                        Content: createElement(UnitsSettings, null),
                                        Title: unwrap(Title_7),
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))), delay(() => {
                                        let elems_9, Title_8;
                                        return append(canManageLabels ? singleton(reactElement("section", createObj(ofArray([["id", "labels-section"], (elems_9 = [createElement(SectionContainer, (Title_8 = t("settings.labels.title"), {
                                            Content: createElement(LabelSettings, {
                                                OnConfigurationChanged: props.OnConfigurationChanged,
                                            }),
                                            Title: unwrap(Title_8),
                                        }))], ["children", reactApi.Children.toArray(Array.from(elems_9))])])))) : empty(), delay(() => {
                                            let elems_10, Title_9;
                                            return append(canManageSso ? singleton(reactElement("section", createObj(ofArray([["id", "sso-section"], (elems_10 = [createElement(SectionContainer, (Title_9 = t("settings.sso.sso"), {
                                                Content: createElement(SSOSettings, {
                                                    UserData: props.UserData,
                                                }),
                                                Title: unwrap(Title_9),
                                            }))], ["children", reactApi.Children.toArray(Array.from(elems_10))])])))) : empty(), delay(() => {
                                                let elems_11, Title_10;
                                                return canManageTelematics ? singleton(reactElement("section", createObj(ofArray([["id", "telematics-section"], (elems_11 = [createElement(SectionContainer, (Title_10 = t("settings.telematics.title"), {
                                                    Content: createElement(TelematicsSettings, null),
                                                    Title: unwrap(Title_10),
                                                }))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))) : empty();
                                            }));
                                        }));
                                    }));
                                }));
                            }));
                        }));
                    }));
                }));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_12))]))))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])));
}

